import { Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel, Radio, RadioGroup } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface NotificationsSectionProps {
  notifications: any
  handleNotificationsChange: (inputName: string) => (event: any) => void
}

export const NotificationsSection = ({ notifications, handleNotificationsChange }: NotificationsSectionProps) => {
  const { t } = useTranslation(['global'])

  return (
    <>
      <FormControl component="fieldset">
        <FormLabel component="legend">Notificaciones</FormLabel>
        <FormGroup>
          <FormControlLabel
            control={<Checkbox checked={notifications.email} onChange={handleNotificationsChange('email')} name="email" />}
            label="Email"
          />
          <FormControlLabel
            control={
              <Checkbox checked={notifications.notification} onChange={handleNotificationsChange('notification')} name="notification" />
            }
            label="Notificacion"
          />
          <FormControlLabel
            control={
              <Checkbox checked={notifications.integration} onChange={handleNotificationsChange('integration')} name="integration" />
            }
            label="Integracion"
          />
        </FormGroup>
      </FormControl>

      <FormControl component="fieldset">
        <FormLabel component="legend">Notificar a:</FormLabel>
        <RadioGroup aria-label="notifyTo" name="notifyTo" value={notifications.hierarchy} onChange={handleNotificationsChange('hierarchy')}>
          <FormControlLabel value="0" control={<Radio />} label={t('all')} />
          <FormControlLabel value="1" control={<Radio />} label={t('commercial')} />
        </RadioGroup>
      </FormControl>
    </>
  )
}
